export default __webpack_public_path__ + "static/media/team1.73369514.jpeg";